import { render, staticRenderFns } from "./shopGoodsCat.vue?vue&type=template&id=5efc424c&"
import script from "./shopGoodsCat.vue?vue&type=script&lang=js&"
export * from "./shopGoodsCat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports